import styled from 'styled-components';
import { theme } from '@salecycle/ui-component-library';
export const StyledCampaignListItem = styled.li`
  padding: 37px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.vars.newColor.lightGS1};
  h3 {
    a:hover {
      text-decoration: none;
    }
    margin-bottom: 10px;
  }
  p {
    color: ${theme.vars.newColor.black};
    margin-bottom: 2px;
  }
  .last-edit {
    font-style: italic;
    color: ${theme.vars.newColor.darkGS3};
  }
  .ruleset-info {
    font-style: italic;
    color: ${theme.vars.newColor.darkGS2};
  }
`;

export const StyledCircleBadge = styled.div`
  display: inline-block;
  text-align: center;
  line-height: 2.5;
  border-radius: 100%;
  border: 1px solid ${theme.vars.newColor.darkGS2};
  height: 36px;
  min-width: 36px;
  color: ${theme.vars.newColor.darkGS2};
`;
